import React from 'react';
import './about.css';

// ================= DATA OBJECT =================

const aboutUsData = {
  title: "गट गट ग्रामपंचायत गावसुत: प्रगतीचा संकल्प",

  intro:
    "गावसुत उमरेड तालुक्यात असलेले, संस्कृती आणि कृषीचे उत्तम मिश्रण असलेले गाव आहे. स्थानिक स्वराज्य संस्था म्हणून आम्ही, गावसुत एक आदर्श, आत्मनिर्भर आणि तंत्रज्ञान-स्नेही गाव बनवण्यासाठी कटिबद्ध आहोत.",

  // ================= VISION =================
  visionTitle: "💡 आमची दृष्टी (Our Vision)",
  vision: [
    { icon: "🌐", title: "डिजिटल ग्राम", description: "ग्रामपंचायतीचे कामकाज पारदर्शक आणि डिजिटल माध्यमांतून चालवणे." },
    { icon: "🌿", title: "पर्यावरण पूरक विकास", description: "गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे." },
    { icon: "🤝", title: "युवा आणि महिला सबलीकरण", description: "शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे." },
  ],

  // ================= SERVICES =================
  servicesTitle: "🏗 सेवा आणि सुविधा",
  services: [
    "पायाभूत सुविधा: उत्तम रस्ते, पाणीपुरवठा आणि सार्वजनिक बांधकाम.",
    "दाखले आणि नोंदी: जन्म-मृत्यू, रहिवासी दाखले वेळेत देणे.",
    "शासकीय योजना: शासनाच्या योजनांचा लाभ नागरिकांपर्यंत पोहोचवणे.",
  ],

  // ================= GRAM PANCHAYAT INFO =================
  gramPanchayatInfo: {
    title: "📄 ग्रामपंचायतीची माहिती",
    details: [
      "ग्रामपंचायतीचे नाव : गावसुत",
      "तालुका : उमरेड",
      "जिल्हा : नागपूर",
      "स्थापना वर्ष : 1994",
      "सदस्य संख्या : 10",
      "सरपंच : श्री. सुभाष विठ्ठल भोयर",
      "उपसरपंच : श्री कृष्णा रघुनाथजी पन्नासे",
      "ग्रामसेवक : श्री. विजय पांडुरंग टोणपे",
      "कार्यालय संपर्क : 9960473271",
      "ईमेल : gavsutgp@gmail.com",
      "पत्ता : गट  ग्रामपंचायत गावसुत,ता.उमरेड जि. नागपूर, महाराष्ट्र, पिन - 441203"
    ]
  },

  // ================= STATISTICS =================
  statistics: {
    title: "📊 ग्रामपंचायत आकडेवारी",
    data: [
      { label: "एकूण लोकसंख्या", value: "1687" },
      
      { label: "लहान मुले (0-6 वर्षे)", value: "-" },
      { label: "एकूण कुटुंबे", value: "-" },
      { label: "साक्षरता दर", value: "100%" },
      { label: "शौचालय असलेली घरे", value: "-" },
      { label: "पिण्याचे पाणी सुविधा", value: "90%" },
      { label: "वीज उपलब्ध घरे", value: "100%" },
      { label: "रस्त्यांची लांबी", value: "1 कि.मी." },
      { label: "शाळांची संख्या", value: "2" },
      { label: "आरोग्य केंद्र", value: "-" },
      { label: "शेतकरी संख्या", value: "-" },
      { label: "जनावरांची संख्या", value: "-" },
      { label: "झाडांची संख्या", value: "-" },
      { label: "सौर दिवे", value: "" },
      { label: "स्वच्छता कर्मचारी", value: "2" },
    ]
    
  },

  
  // ================= FACILITIES =================
 // ================= FACILITIES =================
facilities: {
  title: "🏘 गावातील मुख्य सुविधा",
  population: "1687",

  school: [
    "१) जिल्हा परिषद उच्च प्राथमिक शाळा गावसुत (इ. १ ते ७)",
    "२) जिल्हा परिषद शाळा कोलघाटी (इ. १ ते ४)"
  ],

  healthCenter: "प्राथमिक आरोग्य सुविधा उपलब्ध",

  anganwadi: [
    "१) अंगणवाडी केंद्र क्रमांक १",
    "२) अंगणवाडी केंद्र क्रमांक २"
  ]
},

  // ================= OTHER =================
  education: {
    title: "📚 शिक्षण व्यवस्था",
    content: [
      "जिल्हा परिषद शाळा कार्यरत आहे.",
      "इयत्ता 1 ली ते 7 वी पर्यंत शिक्षण उपलब्ध आहे.",
      "मोफत पुस्तके, गणवेश व शिष्यवृत्ती दिली जाते.",
      "शाळेत पिण्याचे पाणी व स्वच्छतागृह सुविधा आहे.",
    ],
  },

  participation: {
    heading: "🤝 तुमचा सहभाग महत्त्वाचा",
    content: "ग्रामपंचायत ही गावकऱ्यांची संस्था आहे. ग्रामसभेत सहभाग महत्त्वाचा आहे.",
  },

  sarpanch: {
    name: "श्री. सुभाष विठ्ठल भोयर",
    slogan: "👉 प्रत्येक नागरिकाच्या आवाजाला महत्त्व",
    closing: "गावसुत नागरिकांचे प्रेम आणि विश्वास हीच आमची प्रेरणा आहे.",
  },
};

// ================= COMPONENT =================

const VisionItem = ({ icon, title, description }) => (
  <div className="vision-card">
    <div className="vision-icon">{icon}</div>
    <h4>{title}</h4>
    <p>{description}</p>
  </div>
);

const AboutUs = () => {
  const { sarpanch, facilities } = aboutUsData;

  return (
    <div className="page about-us-page">
      <header className="page-header">
        <h1>{aboutUsData.title}</h1>
        <p>{aboutUsData.intro}</p>
      </header>

      <main>

        {/* Vision */}
        <section className="section">
          <h2>{aboutUsData.visionTitle}</h2>
          <div className="vision-cards-container">
            {aboutUsData.vision.map((item, index) => (
              <VisionItem key={index} {...item} />
            ))}
          </div>
        </section>

        {/* Services */}
        <section className="section">
          <h2>{aboutUsData.servicesTitle}</h2>
          <ul>
            {aboutUsData.services.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </section>

        {/* Gram Info */}
        <section className="section bg-light">
          <h2>{aboutUsData.gramPanchayatInfo.title}</h2>
          <div className="gav-info-grid">
            {aboutUsData.gramPanchayatInfo.details.map((item, i) => (
              <div key={i} className="gav-info-card">{item}</div>
            ))}
          </div>
        </section>

        {/* Facilities */}
        <section className="section">
          <h2>{facilities.title}</h2>
          <div className="gav-info-grid">
            <div className="gav-info-card">
              <h3>लोकसंख्या</h3>
              <p><strong style={{fontSize:"28px", color:"#138808"}}>{facilities.population}</strong></p>
            </div>

            <div className="gav-info-card">
              <h3>शाळा</h3>
              <p>{facilities.school}</p>
            </div>

            <div className="gav-info-card">
              <h3>आरोग्य केंद्र</h3>
              <p>{facilities.healthCenter}</p>
            </div>

            <div className="gav-info-card">
              <h3>अंगणवाडी</h3>
              <ul>
                {facilities.anganwadi.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* ✅ Statistics Section */}
        <section className="section bg-light">
          <h2>{aboutUsData.statistics.title}</h2>
          <div className="gav-info-grid">
            {aboutUsData.statistics.data.map((item, index) => (
              <div key={index} className="gav-info-card">
                <h4>{item.label}</h4>
                <p style={{fontWeight:"bold", color:"#0b5ed7"}}>
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Education */}
        <section className="section">
          <h2>{aboutUsData.education.title}</h2>
          <ul>
            {aboutUsData.education.content.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </section>

        {/* Participation */}
        <section className="section">
          <h2>{aboutUsData.participation.heading}</h2>
          <p>{aboutUsData.participation.content}</p>
        </section>

        {/* Sarpanch */}
        <section className="section">
          <h2>सरपंच : {sarpanch.name}</h2>
          <p>{sarpanch.slogan}</p>
          <p><strong>{sarpanch.closing}</strong></p>
        </section>

            
      </main>

      <footer >
        <p>© 2026   गट ग्रामपंचायत गावसुत| सर्व हक्क राखीव</p>
        <p>
          
          <a href="https://gpgavsut.in" >
            gpgavsut.in
          </a>
        </p>
      </footer>
      
     
    </div>
    
  );
};

export default AboutUs;